import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { Container } from "@material-ui/core";
import * as api from "../../api";
import "./index.css";
import RepairDetails from "../RepairDetails/index";
import {
  backToRepairAsset,
  userChosenCurrentValue,
  userChosenHighLevelDescription,
  userChosenRepairLocation,
  userChosenRepairLocationId,
  userChosenNotifyAll,
  dmcInspectionSorCodeValues,
  dmcRepairSorCodeValues,
  vulnerabilityExcludedSorcodeValues,
  saveDMReportPreferenceEnabled,
  saveDMQuestionnaireEnabled,
  userChosenCovidQuestion,
  isEditState,
  userChosenVandalismQuestion,
  userChosenVandalismAdditionalInformation,
  userChosenVulnerabilityQuestion,
  userChosenVulnerabilityAdditionalInformation,
  userChosenDuplicateQuestion,
  userChosenEmergencyQuestion,
} from "../../ducks/redux/actions/userChoices";
import { RouteComponentProps } from "react-router-dom";
import { getReferenceNumber } from "../../ducks/redux/actions/getAddress";
import RepairJourney from "../RepairJourney";
import LoadingSpinner from "../../storybook/LoadingSpinner";
import { Helper } from "../../utils/Helper/HelperUtil";

interface RepairLocationProps extends RouteComponentProps<any> { }

const RepairLocation: React.FC<RepairLocationProps> = (props) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const array: any[] = [];

  const [addresses, setAddresses] = useState(array);
  const [isLoading, setIsLoading] = useState(true);
  const [disabled, setdisabled] = useState(false);

  const [repairLocation, setRepairLocation] = useState("");

  const emailRedirect = useSelector((state: any) => state?.financialReferralReducer?.woRedirectFromEmail);

  const [isRecallValue, setIsRecallValue] = useState(false);
  const IsRecall = useSelector(
    (state: any) => state.userChoicesReducer?.IsRecall
  );
  const EditState = useSelector(
    (state: any) => state.userChoicesReducer?.isEditState
  );
  const userChosenRepairLocationIdBackButton = useSelector(
    (state: any) => state?.userChoicesReducer?.userChosenRepairLocationId
  );

  const resumeDraftRepairVal = useSelector(
    (state: any) => state.userChoicesReducer.resumeDraftRepair
  );
  const communalAssetwithNoHierarchyVal = useSelector(
    (state: any) => state.userChoicesReducer.communalAssetwithNoHierarchy
  );
  const backValue = useSelector(
    (state: any) => state?.userChoicesReducer?.backValue
  );
  const workOrders = useSelector(
    (state: any) => state?.userChoicesReducer?.workOrderData
  );
  const assetDetails = useSelector(
    (state: any) =>
      state?.dashboardReducer?.formState?.assetByIdDataObject
  );
  const isEligibleForEnhancedDiagnostics = useSelector(
    (state: any) => state?.addresses?.isEligibleForEnhancedDiagnostics
  );

  useEffect(() => {
    (async () => {
      try {
        const dmcInspectionSorCodes = await api.GetAppConfigToggleValue("dmcInspectionSorCodes");
        const dmcRepairSorCodes = await api.GetAppConfigToggleValue("dmcRepairSorCodes");
        const vulnerabilityExcludedSorcodes = await api.GetAppConfigToggleValue("vulnerabilityExcludedSorcodes");
        dispatch(dmcInspectionSorCodeValues(dmcInspectionSorCodes?.value));
        dispatch(dmcRepairSorCodeValues(dmcRepairSorCodes?.value));
        dispatch(vulnerabilityExcludedSorcodeValues(vulnerabilityExcludedSorcodes?.value));
      } catch (e: any) {
        console.error(e);
        props.history.push("/GenericError");
      }
      const DMQuestionnaireEnabled = await api.GetAppConfigToggleValue("P360:isDMQuestionnaireEnabled");
      const DMReportPreferenceEnabled = await api.GetAppConfigToggleValue("P360:isDMReportPreferenceEnabled");
      
      if (DMReportPreferenceEnabled) {
        let DMReportPreferenceEnabledValue: boolean = DMReportPreferenceEnabled?.value.toLowerCase() === 'true';
        dispatch(saveDMReportPreferenceEnabled(DMReportPreferenceEnabledValue));
      }
      if (DMQuestionnaireEnabled) {
        let DMQuestionnaireEnabledValue: boolean = DMQuestionnaireEnabled?.value.toLowerCase() === 'true';
        dispatch(saveDMQuestionnaireEnabled(DMQuestionnaireEnabledValue));
      }
    })()
  }, []);

  useEffect(() => {
    if (IsRecall) {
      setIsRecallValue(true)
    }
    else {
      setIsRecallValue(false)
    }
    if (userChosenRepairLocationIdBackButton) {
      setRepairLocation(userChosenRepairLocationIdBackButton);
      setdisabled(true);
    }
  }, []);

  useEffect(() => {
    if (addresses && EditState !== true) dispatch(userChosenRepairLocation(""));
  }, [addresses]);

  useEffect(() => {
    let referenceDataresponsed;
    (async function () {
      try {
        dispatch(userChosenCurrentValue(null));
        dispatch(getReferenceNumber(null))
        //call reference data api

        const namespacenames = assetDetails.assetType;

        let premiseType = namespacenames;
        if (namespacenames === "Estate") {
          premiseType = "estate";
        } else if (
          namespacenames === "Divided Block" ||
          namespacenames === "Divided block"
        ) {
          premiseType = "divided-block";
        } else if (namespacenames === "Estate Area") {
          premiseType = "estate-area";
        }
        referenceDataresponsed = await api.getReferenceData(
          premiseType as string ?? "Property"
        );

        let keyValuePairs: any = "";
        if (referenceDataresponsed) {
          keyValuePairs =
            referenceDataresponsed?.[0]?.namespaces?.[0]?.namespace?.keyValues;
          setAddresses(keyValuePairs);
        }

        setIsLoading(false);
      } catch (e) {
        setIsLoading(false);
        console.error(e);
        props.history.push("/GenericError");
      }
    })();
  }, []);

  let fieldsArray: any[] = [];
  let arrayObject = Object.entries(addresses);
  arrayObject.sort((a, b) => a[1].localeCompare(b[1]));
  arrayObject.forEach((eachLocation, key) => {
    fieldsArray.push(
      <option
        key={eachLocation?.[0]}
        className="block mt-1 width-css mt-1 text-black global-txt"
        value={eachLocation?.[0]}
      >
        {eachLocation[1]}
      </option>
    );
  });

  const backButtonHandler = () => {
    if (emailRedirect) {
      props.history.push("/LandingView");
      return;
    }

    if (!resumeDraftRepairVal && !IsRecall) {
      dispatch(userChosenRepairLocationId(0));
      dispatch(userChosenHighLevelDescription(""));
    }

    if (!resumeDraftRepairVal && isEligibleForEnhancedDiagnostics) {
      props.history.push(Helper.BackRedirectMap[Helper.BackValue.RepairTradeCategory]);
      return;
    }
    if (communalAssetwithNoHierarchyVal) {
      props.history.push(Helper.BackRedirectMap[backValue] ?? `/WorkOrder360View/${workOrders.identifiers.worksOrderIdentifier}`);
      return;
    }
    dispatch(backToRepairAsset(true));
    props.history.push(Helper.BackRedirectMap[Helper.BackValue.RepairAsset]);
  };

  const handleChange = (e: any) => {
    setdisabled(true);
    if (repairLocation !== e.target.value) {
      if (EditState === true) {
        dispatch(userChosenNotifyAll(null));
        dispatch(userChosenCovidQuestion(""));
        dispatch(userChosenVulnerabilityAdditionalInformation(""));
        dispatch(userChosenVulnerabilityQuestion("No"));
        dispatch(userChosenEmergencyQuestion(""));
        dispatch(isEditState(false));
        if (!IsRecall) {
          dispatch(userChosenVandalismAdditionalInformation(""));
          dispatch(userChosenVandalismQuestion("No"));
        }
        dispatch(userChosenDuplicateQuestion(""));
      }
      setRepairLocation(e.target.value);
      dispatch(userChosenRepairLocationId(e.target.value));
      const selectedvalues = addresses[e.target.value];
      dispatch(userChosenRepairLocation(selectedvalues));
      setdisabled(true);
    }
  };

  return (
    <Container id="reploc-container" role="main" className="ctn-fht ">
      <div
        id="RepairLocation-back-div"
        className="container mx-auto mb-0 md:mb-14 lg:mb-10 px-0 xl:px-0"
      >
        <div className="back-and-journey">
          <p id="RepairLocation-p" className="text-teal text-xl mt-4 mb-8">
            <button
              className="back-button_repair_location"
              data-testid="backButtonHandler"
              onClick={backButtonHandler}
              type="button"
            >
              <i className="fas fa-angle-left mr-2"></i>
              {t("back")}
            </button>
          </p>
          <div className=""></div>
          {<RepairJourney />}
        </div>
      </div>

      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <>
          <div
            className="question ml-sm-5 pl-sm-5 repair-text global-txt container"
            id="reploc-main-div"
          >
            <div className="h5" id="reploc-div1">
              <h2 className="text-purple-100 text-2xl mb-2 global-txt ">
                {t("repair_location_label")}
              </h2>
            </div>
            <select
              id="reploc-sel"
              data-testid="dropDownLocation"
              name="dropDownLocation"
              placeholder="dropDownLocation"
              value={repairLocation}
              aria-label="reploc-sel"
              disabled={isRecallValue}
              onChange={handleChange}
              className="block width-css mt-1 text-black global-txt rounded border-grey"
            >
              <option
                value="No option selected"
                className="block mt-1 width-css mt-8 text-black global-txt"
                disabled={disabled}
              >
                Select
              </option>
              {fieldsArray}
            </select>
          </div>
          {<RepairDetails {...props} />}
        </>
      )}
    </Container>
  );
};
export default RepairLocation;